import {BookingOption} from '../enums/BookingOption';
import {DiscountType} from '../enums/DiscountType';

export class Discount {
  id: number;
  value: number;
  type: DiscountType;
  bookingOption: BookingOption;

  public constructor(init?: Partial<Discount>) {
    Object.assign(this, init);
  }
}
